import React, { FC, useEffect, useState } from 'react'
import * as Sentry from '@sentry/react'
import { useApolloClient } from '@apollo/client'
import { PageLayout, Spinner } from '../System'
import { courseFindMany } from '../../graphql/Courses/courseFindMany'
import { CourseType } from '../../types'
import { useNotifications } from '../Notifications'
import { StyledCourseLibraryView, CoursePreviewItem } from '.'

const CourseLibraryView: FC = () => {
  const apollo = useApolloClient()
  const { addNotification } = useNotifications()
  const [courses, setCourses] = useState<CourseType[]>([])
  const [loading, setLoading] = useState(true)

  const loadCourses = async () => {
    try {
      const { data } = await apollo.query({
        fetchPolicy: 'no-cache',
        query: courseFindMany,
        variables: { hideInactive: true }
      })

      const courses = data.courseFindMany.docs

      setCourses(courses)
    }
    catch (err) {
      addNotification({ message: err.message, type: 'error', interval: 10000 })
      Sentry.captureException(err)
    }
    finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadCourses()
  }, [])

  return (
    <PageLayout pageTitle="Courses">
      <StyledCourseLibraryView>
        <div className="course-list">
          {!loading &&
            courses.map((course, index) => {
              return <CoursePreviewItem course={course} isOwned={course.isOwned} key={index} />
            })}
        </div>
        {loading && <Spinner size="large" isBlock />}
      </StyledCourseLibraryView>
    </PageLayout>
  )
}

export default CourseLibraryView
